import { Directive } from '@angular/core';

@Directive({ selector: '[cwtWrapperHeader]' })
export class WrapperHeaderDirective {
    constructor() { }
}